module.exports = __webpack_public_path__ + "img/part1.8c43ce3a.png";